import { __assign } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
export * from './PropsType';
var TouchFeedback = function (props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, activeStyle = props.activeStyle, activeClassName = props.activeClassName, children = props.children;
    var _b = React.useState(false), active = _b[0], setActive = _b[1];
    React.useEffect(function () {
        setActive(false);
    }, [disabled]);
    var triggerEvent = React.useCallback(function (type, isActive, ev) {
        var eventType = "on" + type;
        if (children.props[eventType]) {
            children.props[eventType](ev);
        }
        if (isActive !== active) {
            setActive(isActive);
        }
    }, [active, children]);
    var handleTouchStart = React.useCallback(function (e) {
        triggerEvent('TouchStart', true, e);
    }, [triggerEvent]);
    var handleTouchCancel = React.useCallback(function (e) {
        triggerEvent('TouchCancel', false, e);
    }, [triggerEvent]);
    var handleTouchEnd = React.useCallback(function (e) {
        triggerEvent('TouchEnd', false, e);
    }, [triggerEvent]);
    var handleTouchMove = React.useCallback(function (e) {
        triggerEvent('TouchMove', true, e);
    }, [triggerEvent]);
    var handleMouseDown = React.useCallback(function (e) {
        triggerEvent('MouseDown', true, e);
    }, [triggerEvent]);
    var handleMouseUp = React.useCallback(function (e) {
        triggerEvent('MouseUp', false, e);
    }, [triggerEvent]);
    var events = disabled
        ? undefined
        : {
            onTouchStart: handleTouchStart,
            onTouchCancel: handleTouchCancel,
            onTouchEnd: handleTouchEnd,
            onTouchMove: handleTouchMove,
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
        };
    var child = React.Children.only(children);
    if (!disabled && active) {
        var _c = child.props, className = _c.className, style = _c.style;
        var combineStyle = null;
        var combineCls = classNames(className, activeClassName);
        if (activeStyle) {
            combineStyle = __assign(__assign({}, style), activeStyle);
        }
        return React.cloneElement(child, __assign({ className: combineCls, style: combineStyle }, events));
    }
    return React.cloneElement(child, events);
};
export default TouchFeedback;
